import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { DestroyOptions } from "pixi.js";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";

export class Logo extends DisplayObject {
    private logo: Spine | null = null;

    constructor(config: IDisplayObject) {
        super(config);
        this.init();
    }

    public override destroy(options?: DestroyOptions): void {
        super.destroy(options);
    }

    public playIdle() {
        this.logo.state.setAnimation(0, "animation", true);
    }

    public playWin() {
        this.logo.state.setAnimation(0, "animation", true);
    }

    private init(): void {
        this.logo = Spine.from({
            skeleton: "logoSkel",
            atlas: "logoAtlas",
        });
        this.logo.label = "logo";
        this.addChild(this.logo);
        this.logo.state.setAnimation(0, "animation", true);
    }
}
